import { Button, Grow, Typography, Slider, Backdrop, Divider } from '@mui/material';
import { Box } from '@mui/system';
import React, { useCallback, useState } from 'react'; 
import { useRef } from 'react';
import { useLayoutEffect } from 'react';
import { useEffect } from 'react';
import FileBase from 'react-file-base64';
import getAverageColors from '../../utils/getAverageColors';
import { rgbToHex, truncate } from '../../utils/utils';
import AnimatedButton from '../Buttons/AnimatedButton/AnimatedButton';
import styles from './styles'; 
import getCroppedImg from '../../utils/cropImage';
import ImgDialog from './ImgDialog';
import Cropper from 'react-easy-crop';
import theme from '../../muiTheme';
import { FiX, FiCheck, FiCrop } from "react-icons/fi";
import { HiCamera } from "react-icons/hi";


const ImageUpload = ({onSelected, text, imageLabel, startingImage, sx, forcedAspect, forceCrop, previewSx, editButtonType='external', editButtonSx}) => {

    const [selectedImage, setSelectedImage] = useState(''); 
    const [uploadedFile, setUploadedFile] = useState(null);
    const [preview, setPreview] = useState(); 
    const [validate, setValidate] = useState(false); 
    const [cancelled, setCancelled] = useState(false);
    const hiddenFileInput = useRef(null);
    const [avColors, setAvColors] = useState({avColor1: '#000000', avColor2: '#000000'}); 
    const [gradientBackground, setGradientBackground] = useState('linear-gradient(63deg, rgba(238,174,202,1) 0%, rgba(148,187,233,1) 100%)'); 

    //for image cropping
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [rotation, setRotation] = useState(0);
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [aspectX, setAspectX] = useState(forcedAspect?.x || 4);
    const [aspectY, setAspectY] = useState(forcedAspect?.y || 4);
    const [croppedImage, setCroppedImage] = useState(null); 
    const [showCropScreen, setShowCropScreen] = useState(false);
    const randKey = Math.random() * 100; //added to id so each instance has unique image id for canvas to fetch av colors
    const supportedFileTypes = [
        'image/png',
        'image/jpeg',
        'image/jpg',   
        'image/webp'
    ];

    const buttonText = text || 'Select File'; 

    const fetchAVColors = () => {

        let imageEl = document.getElementById('uploaded-image'+randKey) || document.querySelector('.reactEasyCrop_Image'); 
        let avColors = {rgb: {r: 0, g: 0, b: 0}, rgb2: {r: 0, g: 0, b: 0}}; 

        if(imageEl){

            console.log('image el: ', imageEl);

            avColors = getAverageColors(imageEl);

        }


        console.log('obtained colors: ', avColors);

        let {r, g, b} = avColors.rgb; 
        let {r:r2, g:g2, b:b2} = avColors.rgb2;

        let avColor1 = rgbToHex(r, g, b);
        let avColor2 = rgbToHex( r2, g2, b2);

        console.log('avColor1: ', avColor1, 'avColor2: ', avColor2);

        //change to hex and stringify
        setAvColors( {
            avColor1,
            avColor2
        }); 

        //set gradient background
        let gradBackground = `linear-gradient(45deg, rgb(${r}, ${g}, ${b}, 1) 0%, rgb(${r2}, ${g2}, ${b2}, 1) 100%)`; 
        setGradientBackground(gradBackground);
    }

    useEffect(()=>{

        if(!selectedImage){

            return setPreview(undefined); 
        }

        const objectURL = URL.createObjectURL(selectedImage); 
        setPreview(objectURL);

        if(typeof onSelected === 'function'){

            onSelected(selectedImage, avColors); 

        }

        console.log('selected image: ', selectedImage, 'preview: ', preview);
        return () => {
            /*Remove objectURL on unmount to prevent memory leaks */
            console.log('image upload unmounted');
            URL.revokeObjectURL(objectURL);
        }

    }, [selectedImage, avColors]); 

    useEffect(()=>{

        if(forcedAspect){
            setAspectX(forcedAspect.x);
            setAspectY(forcedAspect.y);
        }
        

    }, []);

    useLayoutEffect(()=>{

        setTimeout(()=>{
            fetchAVColors();
        }, 1500); // wait until img el is in DOM and finished animating
        

    }, [selectedImage]);

    const onImageChange = (event) => {

        console.log('onSelected image, event.files: ', event.files);

        if(!event.target.files || event.target.files.length === 0){


            setCancelled(true);
            return setSelectedImage('', '');

        }

        const fileType = event.target.files[0].type; 

        if(!supportedFileTypes.includes(fileType)){
            setCancelled(true);
            return setSelectedImage('', '');
        }

        setCancelled(false);
        setValidate(true);

        setTimeout(()=>{
            setValidate(false);
        },1000);


        console.log('validate set to true');

        //set cross origin to anon
        let img = event.target.files[0];
        img.crossOrigin = 'Anonymous'; 
        setSelectedImage(img); 
        setUploadedFile(img); //for when user wants to recrop before submission

        //reset parameters in preparation to crop edit 
        
        setCroppedImage(null);
        setZoom(1);
        setRotation(0);

        //if forced crop or forced aspect -- proceed to cropping
        if(forceCrop || forcedAspect){
            setShowCropScreen(true);
        }
    }

    const handleFileInput = (event) => {
        event.preventDefault(); 
        event.stopPropagation(); 
        setCancelled(false);
        hiddenFileInput.current?.click();
    }

    const clickedFileInput = (event) => {

        //for handling file input clicks while window is open
        if(!event.target.files || event.target.files.length === 0){


            setCancelled(true);
            

        }

    }


    //for image cropping
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {

        setCroppedAreaPixels(croppedAreaPixels);
        
    }, []); 

    const showCroppedImage = useCallback(async () => {

        try {

            console.log('ABOUT TO PASS AVCOLORS: ', avColors);
            const croppedImageFile = await getCroppedImg(
                preview,
                croppedAreaPixels,
                rotation,
                { horizontal: false, vertical: false },
                avColors,
            );

            console.log('donee', { croppedImageFile })
            setCroppedImage(croppedImageFile.url);
            setShowCropScreen(false);

            //send cropped image back -- forcing user to crop allows for better control over uploaded images
            if(typeof onSelected === 'function'){

                let blob = croppedImageFile;

                blob.name = selectedImage.name; 
                blob.lastModified = new Date();
                

                onSelected(blob, avColors); 
    
            }



        } catch (e) {
            console.error(e)
        }
    }, [croppedAreaPixels, rotation])
    
    const onCropClose = useCallback(() => {
        setCroppedImage(null);
        setShowCropScreen(false);
        setZoom(1);
        setRotation(0);

    }, [])

    const toggleCropScreen = (event, show = null) => {

        event.preventDefault(); 
        event.stopPropagation(); 

        setShowCropScreen(prev => {

            const value = show ? show : !prev; 

            return value; 
        });    
    }

    const openCropper = () => {

        console.log('open cropper called, preview && croppedImage === null && showCropScreen: ', preview, croppedImage === null, showCropScreen);

        if(croppedImage){

            setSelectedImage(uploadedFile);
        }

        setShowCropScreen(true);
    }

    const handleOverlayClick = (event) => {

        let className = event.target.getAttribute('class') || ''; 
        if(className.includes('popup-overlay')){
            setShowCropScreen(false); 
        }
    }


    return (
        <div style={{...styles.mainContainer, ...sx}}>

            
                

            <Backdrop
                className='popup-overlay'
                onClick={handleOverlayClick}
                open={preview && showCropScreen}
                sx={{
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: '1000'
                }}
            >

                <Box sx={{...styles.cropRoot}}>

                    <Typography variant='h5' sx={{marginBottom: '0px'}}>
                        Crop your image
                    </Typography>

                    <Divider sx={{width: '50%', margin: '30px 0px'}}/>

                    <Box 
                        sx={{
                            ...styles.cropContainer, 
                            '& div.reactEasyCrop_Container': {
                                background: gradientBackground,
                                ...styles.cropContainer['& div.reactEasyCrop_Container']
                            }
                        }}
                    >
                        <Cropper
                            image={preview}
                            crop={crop}
                            rotation={rotation}
                            zoom={zoom}
                            aspect={aspectX / aspectY}
                            restrictPosition={false}
                            onCropChange={setCrop}
                            onRotationChange={setRotation}
                            onCropComplete={onCropComplete}
                            onZoomChange={setZoom}
                        />

                    </Box>

                    <Box sx={styles.controls}>

                        <div style={styles.sliderContainer}>
                            <Typography
                                variant="body2"
                                sx={{ root: styles.sliderLabel, marginRight: '15px' }}
                            >
                                Zoom
                            </Typography>
                            <Slider
                                value={zoom}
                                min={0.2}
                                max={3}
                                step={0.1}
                                aria-labelledby="Zoom"
                                sx={{ root: styles.slider }}
                                onChange={(e, zoom) => setZoom(zoom)}
                            />
                        </div>

                        <div style={styles.sliderContainer}>
                            <Typography
                                variant="body2"
                                sx={{ root: styles.sliderLabel, marginRight: '15px' }}
                            >
                                Rotation
                            </Typography>
                            <Slider
                                value={rotation}
                                min={0}
                                max={360}
                                step={1}
                                aria-labelledby="Rotation"
                                sx={{ root: styles.slider }}
                                onChange={(e, rotation) => setRotation(rotation)}
                            />
                        </div>


                        {
                            !forcedAspect &&
                            <>
                                <div style={styles.sliderContainer}>
                                    <Typography
                                        variant="body2"
                                        sx={{ root: styles.sliderLabel, marginRight: '15px', whiteSpace: 'nowrap' }}
                                    >
                                        {'Aspect-X'}
                                    </Typography>

                                    <Slider
                                        value={aspectX}
                                        min={3}
                                        max={5}
                                        step={0.1}
                                        aria-labelledby="Aspect X"
                                        sx={{ root: styles.slider }}
                                        onChange={(e, x) => setAspectX(x)}
                                    />
                                    
                                </div>

                                <div style={styles.sliderContainer}>
                                    <Typography
                                        variant="body2"
                                        sx={{ root: styles.sliderLabel, marginRight: '15px',whiteSpace: 'nowrap' }}
                                    >
                                        {'Aspect-Y'}
                                    </Typography>

                                    <Slider
                                        value={aspectY}
                                        min={3}
                                        max={5}
                                        step={0.1}
                                        aria-labelledby="Aspect Y"
                                        sx={{ root: styles.slider }}
                                        onChange={(e, y) => setAspectY(y)}
                                    />
                                    
                                </div>
                            </>
                        }

                        

                        <Box
                            sx={{
                                display: 'flex', 
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '20px'
                            }}
                        >

                            <Button 
                                className='form-cancel-button' 
                                sx={styles.formButton} 
                                variant='main' 
                                onClick={(e)=>{toggleCropScreen(e, false)}}>
                                <FiX /> 

                                <span>
                                    Cancel
                                </span>
                            </Button>

                            <Button
                                onClick={showCroppedImage}
                                variant="main"
                                color="primary"
                                sx={styles.formButton }
                            >
                                <FiCheck />
                                <span>
                                    Crop
                                </span>
                            </Button>

                            
                        </Box>
                        

                    </Box>

                </Box>

            </Backdrop>
                
            

            {(selectedImage || startingImage) && 

                <Grow in>
                    <Box
                        width={{xs: 'auto'}}
                        height={{xs: 'auto' }}
                        sx={styles.imagePreviewContainer}

                        >
                        <Typography variant='body1'>
                            {imageLabel || (startingImage && !selectedImage ? 'Your current image' : 'Selected file')}
                        </Typography>

                        <Box
                            sx={{
                                position: 'relative'
                            }}
                        >
                            <img id={'uploaded-image'+randKey} alt='Preview' src={startingImage && !selectedImage ? startingImage : (croppedImage || preview)} style={{...styles.imagePreview, ...previewSx, display: 'block'}}/>

                            {
                                editButtonType === 'inline' &&

                                <HiCamera 
                                    style={{ 
                                        position: 'absolute', 
                                        top: '10px', 
                                        right: '10px',
                                        padding: '15px',
                                        borderRadius: '40px',
                                        color: 'white',
                                        fontSize: '26px',
                                        background: theme.palette.primary.main,
                                        opacity: '0.9',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            opacity: '1',
                                            padding: '18px',
                                        },
                                        ...editButtonSx
                                    }} 
                                    
                                    onClick={handleFileInput}
                                />
                            }
                        </Box>
                        


                    </Box>
                </Grow>
                
                 
            }

            <input
                type='file'
                multiple={false}
                onClick={clickedFileInput}
                onChange={onImageChange}
                style={{display: 'none'}}
                ref={hiddenFileInput}
            >

            </input>

            <Box
                sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}
            >

                {
                    (editButtonType === 'external' || (selectedImage?.length === 0 && !uploadedFile && !startingImage)) &&

                    <AnimatedButton 
                        onClick={handleFileInput}
                        validated={validate}
                        cancelled={cancelled}
                    >
                        {truncate(buttonText, 13)}
                    </AnimatedButton>
                }
                

                { (selectedImage && uploadedFile)  &&

                    <Button variant='main' sx={styles.cropToggle} onClick={openCropper}>

                        <FiCrop />

                        <span>
                            Crop
                        </span>
                    </Button>
                }
            </Box>
            

        </div>
    );
}

export default ImageUpload; 